import { render, staticRenderFns } from "./SubscriptionsRead.vue?vue&type=template&id=64a58cc8&scoped=true&"
import script from "./SubscriptionsRead.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsRead.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsRead.vue?vue&type=style&index=0&id=64a58cc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a58cc8",
  null
  
)

export default component.exports